import { render, staticRenderFns } from "./contactsNumberView.vue?vue&type=template&id=0477962c&scoped=true"
import script from "./contactsNumberView.vue?vue&type=script&lang=js"
export * from "./contactsNumberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477962c",
  null
  
)

export default component.exports